import {ITestsRepository} from './ITestsRepository';
import {tests, test, testsContainsName} from './TestsQueries';
import {createTest} from './TestMutations';
import {Test, TestUpdate} from '../../graphql/API';
import {updateTest} from '../../graphql/mutations';
import {generateClient, GraphQLResult} from 'aws-amplify/api';

const client = generateClient();
export class TestsRepository implements ITestsRepository {
  async getTests(
    nextToken: string | null,
    scannedCount: number | null,
  ): Promise<any> {
    try {
      const response: GraphQLResult<any> = await client.graphql({
        query: tests,
        variables: {nextToken: nextToken, scannedCount: scannedCount},
      });

      return response.data.tests;
    } catch (error) {
      console.log('getTests repository Error:', error);
    }
  }

  async getTestById(testId: string): Promise<any> {
    try {
      const response: GraphQLResult<any> = await client.graphql({
        query: test,
        variables: {
          id: testId,
        },
      });

      return response.data?.test;
    } catch (error) {
      console.log('Fetch test Error: ', error);
    }
  }

  async createTest(test: any): Promise<any> {
    try {
      const createTestResponse: GraphQLResult<any> = await client.graphql({
        query: createTest,
        variables: {
          input: test,
        },
      });

      return createTestResponse.data?.createTest;
    } catch (error) {
      console.log('Create Test Error: ', error);
    }
  }
  async updateTest(
    id: string,
    test: TestUpdate,
    updatedAt: string,
  ): Promise<any> {
    try {
      const updateTestResponse: GraphQLResult<any> = await client.graphql({
        query: updateTest,
        variables: {
          updatedAt,
          id,
          input: test,
        },
      });

      return updateTestResponse.data?.updateTest;
    } catch (error) {
      console.log('Create Test Error: ', error);
    }
  }

  /**
   * @deprecated This method uses the old GraphQL API.
   * Use TestsService.getTestByName() which uses the new searchDailyExercisesByName API instead.
   * This method is kept for backward compatibility but may be removed in future versions.
   */
  async getTestsByName(name: string): Promise<Array<Test>> {
    const allTests: Array<Test> = [];
    let nextToken: string | null = null;
    let scannedCount: number | null = null;

    try {
      do {
        const response: GraphQLResult<any> = await client.graphql({
          query: testsContainsName,
          variables: {
            filter: {name: {contains: name}},
            nextToken: nextToken,
            scannedCount: scannedCount,
          },
        });

        const items = response.data?.tests?.items ?? [];

        allTests.push(...items);

        nextToken = response.data?.tests?.nextToken ?? null;
        scannedCount = response.data?.tests?.scannedCount ?? null;
      } while (nextToken && allTests.length === 0);

      return allTests;
    } catch (error) {
      console.log('Fetch tests by name Error: ', error);
      return [];
    }
  }
}
